import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe.PoiFinder/Resources/Private/Fusion/Presentation/Application/PoiFinder/PoiFinder.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe.PoiFinder/Resources/Private/Fusion/Presentation/Application/PoiFinder/PoiFinder.ts';

export const prototypeName = 'JL5zp780kPCbXkD3Q5N6sd733Z0nOMf9zrRXAARMfNVdbr30JosOx1ZJn8AQckaWNWeA2lTnenDQw0WvSNKbRA';
export {styles};
export {script};